var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { BILoggerContext } from './BILoggerContext';
var BILoggerProvider = /** @class */ (function (_super) {
    __extends(BILoggerProvider, _super);
    function BILoggerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BILoggerProvider.prototype.render = function () {
        return (React.createElement(BILoggerContext.Provider, { value: this.props.logger }, this.props.children));
    };
    return BILoggerProvider;
}(React.Component));
export { BILoggerProvider };
//# sourceMappingURL=BILoggerProvider.js.map